module.exports = __webpack_public_path__ + "static/img/Mediakit.ae1ddf2.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/misc/1x/Mediakit.png
// module id = 4X0j
// module chunks = 1